import * as React from 'react';

import ProjectContentModule from 'bundles/unified-description-page-common/components/modules/project-content/ProjectContentModule';
import InstructorAndPartnerInfo from 'bundles/unified-description-page-common/components/shared/InstructorAndPartnerInfo';
import TogglableDescription from 'bundles/unified-description-page-common/components/shared/TogglableDescription';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';
import { PROJECT_NAV_ITEMS } from 'bundles/unified-description-page-common/utils/getPageNavigationLinks';

import _t from 'i18n!nls/xdp';

type Props = {
  pageData: ConsumerCoursePageFieldsFragment | EnterpriseCoursePageFieldsFragment;
};

const GuidedProjectContentModuleRenderer = ({ pageData }: Props) => {
  return (
    <ProjectContentModule
      title={_t('About this project')}
      description={pageData.cmlLearningObjectives && <TogglableDescription description={pageData.description} />}
      anchorId={PROJECT_NAV_ITEMS.DETAILS}
      content={
        <InstructorAndPartnerInfo
          averageInstructorRating={pageData.averageInstructorRating}
          instructorRatingCount={pageData.instructorRatingCount}
          instructors={pageData.instructors}
          partners={pageData.partners}
          trackingLocation="syllabus"
        />
      }
    />
  );
};

export default GuidedProjectContentModuleRenderer;
